/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\mixins\index.js                                                  *
 * Project: Telemedicine-MyMedicine                                            *
 * Created Date: Monday, December 18th 2023, 6:16:09 pm                        *
 * Author: Vishwanth <vishwanth@codestax.ai>                                   *
 * -----                                                                       *
 * Last Modified:                                                              *
 * Modified By:                                                                *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */


import axios from "axios";

export const mixinFunctions = {
    data() {
        return {
            currentCustomer: ''
        };
    },
    methods: {
        userPageViewTable(pageName) {
            if (!window.xm)
                this.currentCustomer = this.$cookies.get("customerToken");
            else
                this.currentCustomer = localStorage.getItem('customerToken');
            if (this.currentCustomer === null) {
                var userPageViewTableBody = {
                  pageName : pageName,
                  typeOfUser: 'CUSTOMER'
                };
            } else {
                var userPageViewTableBody = {
                  pageName: pageName,
                  typeOfUser: 'CUSTOMER',
                  token: this.currentCustomer
                };
            };
            axios.post(process.env.VUE_APP_BACKEND_URL + "/userPageViewTable", userPageViewTableBody)
            .catch((userPageViewTableError) => {
                console.log('Error in adding userPageViewTable', userPageViewTableError);
            });
        }
    }
};